import React from "react";
import PropTypes from 'prop-types';
import { Typography } from '../../index';
import SelectGroup from './SelectGroup'
import './radio.scss';

export const Radio = ({
    label,
    selected,
    disabled = false,
    variant = 'item', // Item variant has not been created yet
    index,
    optionsLength,
    checked,
    error = false,
    onChange,
    name,
    size = "sm"
}) => {

    const checkSelected = typeof checked === "boolean" ? checked : label === selected;

    const handleOnChange = (e) => {
        if (onChange) {
            onChange(e)
        }
    }
    return (variant === 'select'
        ? <SelectGroup
            checkSelected={checkSelected}
            error={error}
            label={label}
            selected={selected}
            onChange={handleOnChange}
            disabled={disabled}
            index={index}
            optionsLength={optionsLength}
            name={name}
            size={size}
        />
        : <label className={`radio-container ${checkSelected ? "selected-container" : ""}`}>
            <input
                type="radio"
                name={name}
                value={label}
                checked={checkSelected}
                onChange={handleOnChange}
                disabled={disabled}
            />
            <span className="checkmark" />
            <Typography type="body-02">
                {label}
            </Typography>
        </label>
    );
};
